export const searchObject = (search, object) => {
    const s = search.toLocaleLowerCase();
    const o = JSON.stringify(object).toLocaleLowerCase();
    return o.indexOf(s) > -1;
};
export const searchObjectCurried = (search) => (object) => {
    const s = search.toLocaleLowerCase();
    const o = JSON.stringify(object).toLocaleLowerCase();
    return o.indexOf(s) > -1;
};
//# sourceMappingURL=search.js.map